<template>
    <div>
        <h4 class="text-yellow-500 uppercase text-[9px] block text-center mt-3 after:w-2 after:h-2 after:inline-block after:top-[1px] after:ml-2 after:relative after:rounded-full after:bg-red-600">
            <slot></slot>
        </h4>
        
        <div class="relative h-24 mb-2">
            <svg viewBox="0 0 36 36" class="block my-3 mx-auto w-24 h-24">
                <path
                    fill="none"
                    stroke-width="3"
                    stroke="#fff"
                    d="M18 2.0845
                    a 15.9155 15.9155 0 0 1 0 31.831
                    a 15.9155 15.9155 0 0 1 0 -31.831"
                />
                <path class="circle"
                    fill="none"
                    stroke-width="3"
                    stroke-linecap="round"
                    :stroke-dasharray="percentage + ' 100'"
                    stroke="#fed129"
                    d="M18 2.0845
                    a 15.9155 15.9155 0 0 1 0 31.831
                    a 15.9155 15.9155 0 0 1 0 -31.831"
                />
            </svg>

            <span class="flex mt-[-74px] justify-center items-center">
                <span class="text-yellow-500 font-bold text-2xl">{{ percentage }}</span>
                <span class="text-yellow-500 text-xs">%</span>
            </span>
        </div>

        <p class="text-yellow-500 text-[9px] block text-center uppercase">
            Meta - <span class="lowercase">{{ target }}</span>
        </p>

        <p class="text-yellow-500 text-[9px] block text-center uppercase">
            Realizado - <span class="normal-case">{{ progress }}</span>
        </p>
    </div>
</template>

<script>
export default {
    props: {
        target: {
            type: String,
            default: '0'
        },
        progress: {
            type: String,
            default: 'Aguarde'
        },
        percentage: {
            type: Number,
            default: 0
        }
    }
}
</script>